import { useState } from 'react'
import AboutOverviewWheel from './AboutOverviewWheel'
import maharajJiImg from '../../../assets/images/maharaj-ji.png'
export default function AboutOverviewPortrait() {
  const [imgFailed, setImgFailed] = useState(false)

  return (
    <div className="relative flex justify-center" style={{ maxWidth: '100%', width: '100%', margin: '0 auto' }}>
      <AboutOverviewWheel />

      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        aria-hidden="true"
        style={{ width: '72%', height: '72%', borderRadius: '50%', background: 'radial-gradient(circle,rgba(245,158,11,.14) 0%,transparent 65%)', filter: 'blur(40px)', zIndex: 0 }}
      />

      <div
        className="relative overflow-hidden"
        style={{
          width: '100%',
          maxWidth: '490px',
          aspectRatio: '3/4',
          borderRadius: '28px',
          border: '1.5px solid rgba(180,83,9,.28)',
          boxShadow: '0 40px 80px -20px rgba(120,53,15,.22),0 0 0 1px rgba(245,158,11,.10),0 0 60px -10px rgba(245,158,11,.14)',
          zIndex: 1,
        }}
      >
        <div style={{ position: 'absolute', top: '-1px', left: '-1px', width: '28px', height: '28px', borderTop: '2.5px solid rgba(180,83,9,.80)', borderLeft: '2.5px solid rgba(180,83,9,.80)', borderRadius: '22px 0 0 0', zIndex: 6, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '28px', height: '28px', borderBottom: '2.5px solid rgba(180,83,9,.80)', borderRight: '2.5px solid rgba(180,83,9,.80)', borderRadius: '0 0 22px 0', zIndex: 6, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: '-1px', right: '-1px', width: '28px', height: '28px', borderTop: '2px solid rgba(180,83,9,.42)', borderRight: '2px solid rgba(180,83,9,.42)', borderRadius: '0 22px 0 0', zIndex: 6, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-1px', left: '-1px', width: '28px', height: '28px', borderBottom: '2px solid rgba(180,83,9,.42)', borderLeft: '2px solid rgba(180,83,9,.42)', borderRadius: '0 0 0 22px', zIndex: 6, pointerEvents: 'none' }} />

        {!imgFailed && (
          <img
            src={maharajJiImg}
            alt="Astrologer Raju Maharaj Ji — Vedic Jyotish Acharya"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: 'center top' }}
            loading="lazy"
            onError={() => setImgFailed(true)}
          />
        )}
        {imgFailed && (
          <div className="absolute inset-0 flex items-center justify-center flex-col gap-2" style={{ background: 'linear-gradient(145deg,#F5EDD8,#E8D5A3)' }}>
            <span className="font-royal" style={{ fontSize: '64px', color: 'rgba(180,83,9,.35)' }}>
              ॐ
            </span>
            <span style={{ fontSize: '9px', letterSpacing: '.3em', textTransform: 'uppercase', color: 'rgba(120,53,15,.40)' }}>Maharaj Ji</span>
          </div>
        )}

        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '45%', background: 'linear-gradient(to top,rgba(28,10,4,.92) 0%,rgba(28,10,4,.65) 40%,transparent 100%)', zIndex: 2 }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 22px', zIndex: 3, borderTop: '1px solid rgba(245,158,11,.18)' }}>
          <p style={{ fontSize: '7.5px', letterSpacing: '.45em', textTransform: 'uppercase', color: 'rgba(245,158,11,.72)', marginBottom: '3px' }}>Vedic Master</p>
          <p className="font-royal" style={{ fontSize: '17px', fontWeight: 700, color: '#FFFFFF', letterSpacing: '.05em', lineHeight: 1.15, textTransform: 'uppercase' }}>
            Raju Maharaj Ji
          </p>
        </div>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.65),transparent)', zIndex: 3 }} />
      </div>

      <div
        className="animate-float"
        style={{
          position: 'absolute',
          top: '-14px',
          right: '-14px',
          zIndex: 10,
          borderRadius: '18px',
          padding: '12px 16px',
          background: 'linear-gradient(135deg,#b86e08,#F5A623,#d4870f)',
          boxShadow: '0 10px 32px -6px rgba(245,158,11,.65),0 2px 10px rgba(0,0,0,.22),inset 0 1px 0 rgba(255,255,255,.22)',
          animationDelay: '0s',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '18px', lineHeight: 1 }}>🏆</span>
          <div>
            <p style={{ fontFamily: 'var(--font-heading),serif', fontSize: '16px', fontWeight: 900, color: '#fff', letterSpacing: '.06em', lineHeight: 1, textShadow: '0 1px 3px rgba(0,0,0,.25)' }}>
              15+
            </p>
            <p style={{ fontSize: '7px', textTransform: 'uppercase', letterSpacing: '.18em', color: 'rgba(255,255,255,.82)', marginTop: '2px' }}>Years Exp.</p>
          </div>
        </div>
      </div>

      <div
        className="animate-float"
        style={{
          position: 'absolute',
          top: '42%',
          left: '-20px',
          transform: 'translateY(-50%)',
          zIndex: 10,
          borderRadius: '18px',
          padding: '12px 16px',
          background: '#FFFFFF',
          border: '1px solid rgba(180,83,9,.18)',
          boxShadow: '0 10px 36px -6px rgba(0,0,0,.12),0 2px 8px rgba(180,83,9,.08)',
          animationDelay: '-2.5s',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg,rgba(245,158,11,.20),rgba(180,83,9,.08))',
              border: '1px solid rgba(180,83,9,.18)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              flexShrink: 0,
            }}
          >
            🔮
          </div>
          <div>
            <p style={{ fontFamily: 'var(--font-heading),serif', fontSize: '16px', fontWeight: 900, color: '#B45309', letterSpacing: '.06em', lineHeight: 1 }}>10K+</p>
            <p style={{ fontSize: '7px', textTransform: 'uppercase', letterSpacing: '.18em', color: 'rgba(92,58,30,.55)', marginTop: '2px' }}>Sessions</p>
          </div>
        </div>
      </div>

      <div
        className="animate-float"
        style={{
          position: 'absolute',
          top: '18px',
          left: '18px',
          zIndex: 10,
          borderRadius: '12px',
          padding: '8px 14px',
          background: 'linear-gradient(135deg,#D97706,#F59E0B)',
          boxShadow: '0 6px 20px -4px rgba(217,119,6,.55)',
          display: 'flex',
          alignItems: 'center',
          gap: '7px',
          animationDelay: '-1.2s',
        }}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
        <span style={{ fontSize: '8px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.22em', color: '#fff', whiteSpace: 'nowrap' }}>Verified Expert</span>
      </div>
    </div>
  )
}
